import React from "react";
import { FaPhone, FaEnvelope } from "react-icons/fa";

function ContactCard({ contact, onClick }) {
  return (
    <div
      className="bg-white rounded-xl shadow-sm hover:shadow-md transition-all duration-300 p-4 w-full cursor-pointer"
      onClick={onClick}
    >
      <div className="flex items-start gap-4">
        <div className="flex-shrink-0">
          <div className="w-16 h-16 rounded-full bg-[#363062]/10 flex items-center justify-center overflow-hidden">
            {contact.photoUrl ? (
              <img
                src={contact.photoUrl}
                alt={contact.name}
                className="w-full h-full object-cover"
              />
            ) : (
              <span className="text-xl font-semibold text-[#363062]">
                {contact.name.charAt(0)}
              </span>
            )}
          </div>
        </div>
        <div className="flex-1 min-w-0">
          <h3 className="text-lg font-semibold text-[#363062] truncate">
            {contact.name}
          </h3>
          <p className="text-sm text-gray-600 mt-0.5">{contact.title}</p>

          <div className="mt-2 space-y-1.5">
            <div className="flex items-center gap-2 text-sm text-gray-600">
              <FaPhone className="text-[#363062] w-3.5 h-3.5" />
              <span>{contact.contactNumber}</span>
            </div>

            <div className="flex items-center gap-2 text-sm text-gray-600">
              <FaEnvelope className="text-[#363062] w-3.5 h-3.5" />
              <span className="truncate">{contact.email}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ContactCard;